import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import { formatNum, getCategory, sortByPopularity } from "@/utils/manga";
import SectionTitle from "@/components/feature/SectionTitle";

const rankColors = ["bg-primary-500", "bg-secondary-500", "bg-accent-500"];

export default function Ranking() {
  const top = sortByPopularity(mangaList).slice(0, 6);
  const first = top[0];
  return (
    <section className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionTitle
          eyebrow="实时榜单"
          title="人气排行榜"
          subtitle="根据阅读热度与收藏数据实时更新的热门漫画榜单，看看大家都在看什么。"
          to="/rankings"
          moreLabel="完整榜单"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* 榜首 featured */}
          {first && (
            <Link
              to={`/manga/${first.id}`}
              className="group relative overflow-hidden rounded-lg border border-background-200/70 bg-background-50 lg:col-span-1"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={first.cover}
                  alt={`榜首 ${first.title} 漫画`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent"></div>
                <div className="absolute left-3 top-3 flex items-center gap-2">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-xl text-background-50 shadow-sm">
                    1
                  </span>
                  <span className="rounded-md bg-background-50/85 px-2 py-1 text-xs font-medium text-primary-700">
                    本周人气榜首
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <h3 className="font-heading text-2xl text-background-50">{first.title}</h3>
                  <p className="mt-1 flex flex-wrap items-center gap-2 text-xs text-background-50/80">
                    <span>{getCategory(first.category).name}</span>
                    <span>·</span>
                    <span>{first.status}</span>
                    <span>·</span>
                    <span className="flex items-center gap-0.5 text-secondary-300">
                      <i className="ri-star-fill" /> {first.rating.toFixed(1)}
                    </span>
                  </p>
                  <p className="mt-2 line-clamp-2 text-sm text-background-50/85">{first.intro}</p>
                </div>
              </div>
            </Link>
          )}

          {/* 2-6 榜单列表 */}
          <div className="lg:col-span-2">
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {top.slice(1).map((m, i) => {
                const rank = i + 2;
                return (
                  <li key={m.id}>
                    <Link
                      to={`/manga/${m.id}`}
                      className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-200 hover:shadow-sm"
                    >
                      <span
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-lg text-background-50 ${
                          rankColors[rank - 1] || "bg-foreground-500"
                        }`}
                      >
                        {rank}
                      </span>
                      <img src={m.cover} alt={`${m.title} 封面`} className="h-16 w-12 shrink-0 rounded-md object-cover" />
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-sm font-semibold text-foreground-950">{m.title}</span>
                        <span className="mt-0.5 block truncate text-xs text-foreground-500">
                          {getCategory(m.category).name} · {m.status}
                        </span>
                        <span className="mt-1 flex items-center gap-1 text-xs text-primary-600">
                          <i className="ri-fire-line" />
                          人气 {formatNum(m.popularity)}
                        </span>
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}